import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ModalProvider } from 'react-modal-hook';
import App from './components/App';
import Config from './components/Config';
import reducers from './reducers';
import ai from './middleware/ai-middleware';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk, ai)))

const init = ( config = {}) => {
    if(!config.appElement)
        config.appElement='root';
    ReactDOM.render(
        <Provider store={store}>
            <ModalProvider>
                <Config config={config}>
                    <App />
                </Config>
            </ModalProvider>
        </Provider>,
        document.getElementById(config.appElement)
    )
}
init();
export { init };